import _ from 'lodash';
import { useContext } from "react";
import KanbanFunctions from "../../api/kanban-board/kanban-functions";
import { Tile } from "./tile";
import { Panel } from '../../components/panel/panel.jsx';
import { Droppable, Draggable } from "@hello-pangea/dnd";
import { KanbanPanelHeader } from "./kanban-panel-header";
import { KanbanContext } from './../../pages/kanban-board/kanban-board';
import { arrayAny } from '../../utils/arrayUtils.js';

export const Columns = ({ project, showTaskDelete, showPriorityBadge, showViewDetailsButton, onViewDetails }) => {

    const context = useContext(KanbanContext);
    const { moveColumn, deleteColumn } = context || {};
    

    const isFirstColumn = (project, column) => {
        const minId = _.minBy(project.columns, c => c.displayOrder).displayOrder;
        return column.displayOrder === 0 && minId === 0;
    }

    const isLastColumn = (project, column) => {
        const maxId = _.maxBy(project.columns, c => c.displayOrder).displayOrder;
        return column.displayOrder === maxId;
    }

    const moveLeft = async (project, column) => {
        if (moveColumn) {
            await moveColumn(project, column, "left");
        }
    }

    const moveRight = async (project, column) => {
        if (moveColumn) {
            await moveColumn(project, column, "right");
        }
    }

    return project && arrayAny(project.columns) && (
        <>
            {KanbanFunctions.columnsInOrder(project.columns).map(column => ( // foreach column in data render column

                <div key={`project-${project.id}-column-${column.columnId}`} className="col-12 col-sm-4 mb-3">

                    <Panel
                        moveLeft={moveColumn ? async () => await moveLeft(project, column) : undefined}
                        moveRight={moveColumn ? async () => await moveRight(project, column) : undefined}
                        deleteColumn={deleteColumn ? async () => await deleteColumn(project, column) : undefined}
                    >
                        <KanbanPanelHeader
                            showLeft={moveColumn && !isFirstColumn(project, column)}
                            showRight={moveColumn && !isLastColumn(project, column)}
                            isMobile={false}
                            showDelete={deleteColumn && !isFirstColumn(project, column)}
                        >
                            <div style={{ textTransform: "capitalize" }}>{column.name}  ({column.items.length}) </div>
                        </KanbanPanelHeader>

                        <Droppable droppableId={column.name}>

                            {(provided) => (
                                <div className="list-group list-group-flush rounded-bottom overflow-hidden panel-body p-1"
                                    ref={provided.innerRef} {...provided.droppableProps}>
                                    {_.uniqBy(_.orderBy(_.filter(column.items, i => !!i), b => { return !!b ? b.order : 0; }), t => t.id)
                                        .map((item, index) => ( // For each Tile

                                            <Draggable
                                                key={item.id}
                                                draggableId={item.id}
                                                index={index}
                                                isDragDisabled={item.saving}
                                            >
                                                {(provided) => (
                                                    <Tile
                                                        tileRef={provided.innerRef}
                                                        project={project}
                                                        tile={item}
                                                        column={column}
                                                        provider={provided}
                                                        updater={null}
                                                        editable={true}
                                                        showTileDelete={showTaskDelete}
                                                        showPriorityBadge={showPriorityBadge ?? true}
                                                        showViewDetailsButton={showViewDetailsButton}
                                                        onViewDetails={onViewDetails}
                                                    ></Tile>
                                                )}
                                            </Draggable>
                                        ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Panel>
                </div>
            ))}

        </>
    )
};